var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0001 6H8.5901L5.2901 2.71C5.1018 2.5217 4.99601 2.2663 4.99601 2C4.99601 1.7337 5.1018 1.47831 5.2901 1.29C5.47841 1.1017 5.7338 0.995911 6.0001 0.995911C6.26641 0.995911 6.5218 1.1017 6.7101 1.29L11.7101 6.29C11.8011 6.38511 11.8725 6.49725 11.9201 6.62C12.0201 6.86346 12.0201 7.13654 11.9201 7.38C11.8725 7.50275 11.8011 7.6149 11.7101 7.71L6.7101 12.71C6.61714 12.8037 6.50654 12.8781 6.38468 12.9289C6.26282 12.9797 6.13212 13.0058 6.0001 13.0058C5.86809 13.0058 5.73739 12.9797 5.61553 12.9289C5.49367 12.8781 5.38307 12.8037 5.2901 12.71C5.19637 12.617 5.12198 12.5064 5.07121 12.3846C5.02044 12.2627 4.99431 12.132 4.99431 12C4.99431 11.868 5.02044 11.7373 5.07121 11.6154C5.12198 11.4936 5.19637 11.383 5.2901 11.29L8.5901 8H1.0001C0.734887 8 0.480533 7.89465 0.292996 7.70711C0.10546 7.51957 0.000103951 7.26522 0.000103951 7C0.000103951 6.73479 0.10546 6.48043 0.292996 6.2929C0.480533 6.10536 0.734887 6 1.0001 6Z",
    fill: "#717171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.4090ae34d5217e64f434ebfc12241acb.svg";
export { ForwardRef as ReactComponent };